var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Balance requests")]),(_vm.soft_loading)?_c('Loader',{attrs:{"soft":true}}):_vm._e(),_c('Table',{staticClass:"margin-top",attrs:{"columns":_vm.columns,"rows":_vm.records}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }